<template>
  <div class="ws-fin-summary">
    <div class="ws-fin-summary__card ws-fin-summary__card--pending">
      <div class="ws-fin-summary__top">
        <span class="ws-fin-summary__icon" aria-hidden="true">
          <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2">
            <path stroke-linecap="round" stroke-linejoin="round" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"/>
          </svg>
        </span>
      </div>
      <span class="ws-fin-summary__label">{{ t('workspaceFinanceiro.totals.pending') }}</span>
      <strong class="ws-fin-summary__value"><MoneyAmount :value="resumo.valorPendente" size="lg" /></strong>
      <div class="ws-fin-summary__footer">
        <span class="ws-fin-summary__meta">{{ resumo.qtdPendente }} {{ t('workspaceFinanceiro.totals.items') }}</span>
        <span v-if="totalGeral > 0" class="ws-fin-summary__pct">{{ pct(resumo.valorPendente) }}%</span>
      </div>
    </div>

    <div class="ws-fin-summary__card ws-fin-summary__card--overdue">
      <div class="ws-fin-summary__top">
        <span class="ws-fin-summary__icon" aria-hidden="true">
          <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2">
            <path stroke-linecap="round" stroke-linejoin="round" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"/>
          </svg>
        </span>
      </div>
      <span class="ws-fin-summary__label">{{ t('workspaceFinanceiro.totals.overdue') }}</span>
      <strong class="ws-fin-summary__value"><MoneyAmount :value="resumo.valorVencido" size="lg" /></strong>
      <div class="ws-fin-summary__footer">
        <span class="ws-fin-summary__meta">{{ resumo.qtdVencido }} {{ t('workspaceFinanceiro.totals.items') }}</span>
        <span v-if="totalGeral > 0" class="ws-fin-summary__pct">{{ pct(resumo.valorVencido) }}%</span>
      </div>
    </div>

    <div class="ws-fin-summary__card ws-fin-summary__card--paid">
      <div class="ws-fin-summary__top">
        <span class="ws-fin-summary__icon" aria-hidden="true">
          <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2">
            <path stroke-linecap="round" stroke-linejoin="round" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"/>
          </svg>
        </span>
      </div>
      <span class="ws-fin-summary__label">{{ t('workspaceFinanceiro.totals.received') }}</span>
      <strong class="ws-fin-summary__value"><MoneyAmount :value="resumo.valorPago" size="lg" /></strong>
      <div class="ws-fin-summary__footer">
        <span class="ws-fin-summary__meta">{{ resumo.qtdPago }} {{ t('workspaceFinanceiro.totals.items') }}</span>
        <span v-if="totalGeral > 0" class="ws-fin-summary__pct">{{ pct(resumo.valorPago) }}%</span>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import MoneyAmount from '@/components/MoneyAmount.vue'

const { t } = useI18n()

const props = defineProps({
  resumo: { type: Object, default: () => ({}) }
})

const resumo = computed(() => ({
  valorPendente: Number(props.resumo?.valorPendente) || 0,
  valorVencido: Number(props.resumo?.valorVencido) || 0,
  valorPago: Number(props.resumo?.valorPago) || 0,
  qtdPendente: props.resumo?.qtdPendente ?? 0,
  qtdVencido: props.resumo?.qtdVencido ?? 0,
  qtdPago: props.resumo?.qtdPago ?? 0
}))

const totalGeral = computed(() =>
  resumo.value.valorPendente + resumo.value.valorVencido + resumo.value.valorPago
)

const pct = (v) => {
  if (totalGeral.value <= 0) return 0
  return Math.round((Number(v) / totalGeral.value) * 100)
}
</script>
